import styled from 'styled-components';
export const ApplicationProgressionBodyContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
`;
export const ApplicationProgressionBodyInfosContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
`;
